<template>
  <section class="footer">
    <button class="btn btn-secondary" @click.prevent="$emit('closeModalPessoa')">
      Cancelar
    </button>
    <button class="btn btn-primary" @click.prevent="$emit('savePessoa')">
      Salvar
    </button>
  </section>
</template>
<script setup>

</script>

<style scoped lang="scss">
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>